<template>
  <div class="userinfo">
    <header-bar :name='"填写领奖信息"'></header-bar>
    <div class="content">
      <div class="top_content clearfix">
        <div class="tip">
          {{getUserInfo.username}} ，您好！
        </div>
        <div v-if="getUserInfo.express === 0">
          <div class="tip2">请您认真填写如下信息，我的的工作人员会通过或者手机短信/微信与您取得联系，将奖品“当当V卡的卡密信息”一对一发送给您，获奖人需要通过邮件或短信/微信回复奖品收到的确认信息后，完成收奖流程</div>
          <div class="tip2">我们工作人员的邮箱为：zhengji@chineseplus.net；QQ号码：2151697624 </div>
          <div class="tip3">以下信息仅供认证获奖人身份及邮寄奖品使用，我们会严格保护您的信息安全，请安心填写。</div>
          <!-- <div class="tab" :class="{ 'active': activeTab == '本人领奖'}"  @click="changeTab('本人领奖')">本人领奖</div>
          <div class="tab" :class="{ 'active': activeTab == '他人代领'}" @click="changeTab('他人代领')">他人代领</div> -->
        </div>
        <div class="tip2" v-if="getUserInfo.express === 1">
          您的邮寄地址信息已提交成功，请您耐心等待，我们将为您邮寄礼品，如有任何问题，请您联系我们的官方邮箱：zhengji@chineseplus.net
        </div>
      </div>

      <div class="form_wrap" v-if="getUserInfo.express === 0">
        <div class="formItem clearfix">
          <div class="formName">领奖人姓名</div>
          <div class="formIcon">
            <img src="../img/m/arrow_right.png" alt="" class="arrow">
          </div>
          <div class="formCon">
            <input type="text" placeholder="请输入" v-model="infoForm.express_username">
          </div>
        </div>
        <!-- <div class="formItem note clearfix">
          <div class="formName">邮寄地址</div>
          <div class="formCon">
            <textarea name="" id="" cols="10" rows="5" placeholder="100字以内" v-model="infoForm.express_address"></textarea>
          </div>
        </div> -->
        <div class="formItem clearfix">
          <div class="formName">领奖人国内电话号码</div>
          <div class="formIcon">
            <img src="../img/m/arrow_right.png" alt="" class="arrow">
          </div>
          <div class="formCon">
            <input type="text" placeholder="请输入" v-model="infoForm.express_tel">
          </div>
        </div>
        <div class="formItem clearfix">
          <div class="formName">领奖人邮箱人</div>
          <div class="formIcon">
            <img src="../img/m/arrow_right.png" alt="" class="arrow">
          </div>
          <div class="formCon">
            <input type="text" placeholder="请输入" v-model="infoForm.express_email">
          </div>
        </div>
        <div class="formItem clearfix">
          <div class="formName">领奖人微信号</div>
          <div class="formIcon">
            <img src="../img/m/arrow_right.png" alt="" class="arrow">
          </div>
          <div class="formCon">
            <input type="text" placeholder="请输入" v-model="infoForm.express_wechat">
          </div>
        </div>
        <div class="formItem clearfix">
          <div class="formName">身份证或护照号码</div>
          <div class="formIcon">
            <img src="../img/m/arrow_right.png" alt="" class="arrow">
          </div>
          <div class="formCon">
            <input type="text" placeholder="请输入" v-model="infoForm.express_id_card">
          </div>
        </div>
      </div>
    </div>
    <div class="submit_btn" @click="submitForm()" v-if="getUserInfo.express === 0">
      提交
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { Notify } from 'vant'
import headerBar from './common/headerBar'

export default {
  components: {
    headerBar
  },
  data () {
    return {
      // activeTab: '本人领奖',
      countryList: [],
      infoForm: {
        express_wechat: '',
        express_username: '',
        express_tel: '',
        express_id_card: '',
        express_email: ''
      },
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.checkUser()
    this.getCountryList()
  },
  methods: {
    // 切换tab
    // changeTab (name) {
    //   if (this.activeTab !== name) {
    //     this.activeTab = name
    //     if (this.activeTab == '本人领奖') {
    //       this.infoForm.receive_type = 1
    //     } else {
    //       this.infoForm.receive_type = 2
    //     }
    //   }
    // },
    getCountryList() {
      this.$utils.get('/user/get-country-list').then(res => {
        this.countryList = res.data
      })
    },
    //判断用户
    checkUser(){
      console.log(this.getUserInfo)
      if( this.getUserInfo.have_award != 1 ){
        this.$message({
          message: '您未获奖，无权限访问',
          type: 'warning'
        });
        this.$router.push('/mpage/m_home');
      }
    },
    // 提交
    submitForm () {
      if (!this.infoForm.express_email) {
        Notify({ type: 'warning', message: '邮箱不能为空' })
        return
      }
      if (!this.infoForm.express_username) {
        Notify({ type: 'warning', message: '姓名不能为空' })
        return
      }
      if (!this.infoForm.express_tel) {
        Notify({ type: 'warning', message: '手机号不能为空' })
        return
      }
      if (!this.infoForm.express_wechat) {
        Notify({ type: 'warning', message: '微信号不能为空' })
        return
      }
      if (!this.infoForm.express_id_card) {
        Notify({ type: 'warning', message: '身份证或护照号码不能为空' })
        return
      }

      this.$utils.postForm('/user/express-info', this.infoForm).then(res => {
        if(res.code == 1000) {
          Notify({ type: 'success', message: '提交成功！' })
          setTimeout(() => {
            this.$router.push({
              path: '/mpage/m_certificateDetail'
            })
          }, 2000)
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .content {
    padding: .3rem .45rem 0 .45rem;
    box-sizing: border-box;
    .top_content {
      background: #fff2f7;
      padding: 0.7rem 0.85rem 0.1rem 0.85rem;
      margin-bottom: 0.5rem;
      .tip {
        color: #fd7777;
        font-size: .5rem;
        line-height: 1.4;
        margin-bottom: .5rem;
      }
      .tip2 {
        font-size: .33rem;
        color: #000000;
        line-height: 1.4;
        margin-bottom: .2rem;
      }
      .tip3 {
        font-size: .33rem;
        color: #999999;
        line-height: 1.4;
        margin-bottom: .5rem;
      }
      .tab {
        width: 50%;
        height: 1.5rem;
        line-height: 1.48rem;
        float: left;
        color: #818181;
        font-size: .6rem;
        background: #dadcde;
        text-align: center;
        &.active {
          color: #404040;
          background: #fff;
        }
      }
    }
    .formItem {
      background: #fff;
      border-bottom: .01rem solid #ccc;
      padding: .4rem .78rem .4rem .7rem;
      box-sizing: border-box;
      line-height: 1.8;
      .formName {
        font-size: .6rem;
        color: #282828;
        float: left;
      }
      .formCon {
        float: right;
        width: 50%;
        height: 1.2rem;
        padding-right: 0.4rem;
        box-sizing: border-box;
        color: #282828;
        font-size: .6rem;
        text-align: right;
        &.conHolder {
          color: #999;
        }
        input {
          width: 100%;
          height: 1.2rem;
          color: #282828;
          display: block;
          background-color: transparent;
          border: 0;
          padding: 0;
          margin: 0;
          resize: none;
          text-align: right;
          font-size: .5rem;
        }
        textarea {
          font-size: .5rem;
        }
      }
      .formIcon {
        float: right;
        .arrow {
          width: .3rem;
          margin-top: .35rem;
        }
        .calendar {
          width: .46rem;
          margin-top: .35rem;
        }
      }
      &.note {
        .formName {
          float: none;
        }
        .formCon {
          float: none;
          text-align: left;
          width: 100%;
          height: 3rem;
          padding: 0;
          input {
            text-align: left;
          }
          textarea {
            width: 100%;
            height: 3rem;
            border: 0;
            resize: none;
            padding: 0;
          }
        }
      }
    }
  }
  .submit_btn {
    width: 100%;
    height: 2.41rem;
    background-color: #333;
    color: #fff;
    font-size: .8rem;
    text-align: center;
    line-height: 2.41rem;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #999;
  }
}
</style>
